import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dataFilterTitle',
})
export class DataFilterTitlePipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            return _.filter(array, row => row.title.toLowerCase().indexOf(query.toLowerCase()) > -1);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/dataFilterTitle/data-filter-title.pipe.ts